import Analytics from './analytics';
import ga from './ga';

class AnalyticsFactory {
	static createAnalytics(provider: string): Analytics {
		if (provider === 'ga') {
			return ga;
		}
		//TODO - Add more if else conditions based on future analytics providers
		//returning default as ga for now
		return ga;
	}
}
export default AnalyticsFactory;
